import UserApi from '../api'

export const getCurrentUser = async ({ commit, rootState }) => {
  // rootState.catalog.defaultDocument = 'schet'
  let response = await UserApi.getCurrentUser()
  if (response.success) {
    commit('SET_USER', response.current_user)
    commit('SET_MANAGERS', response.managers)
    commit('SET_ALLOW_B', response.allow_b)
    commit('SET_ALLOW_BB', response.allow_bb)
    commit('SET_SHOW_BALANCE', response.show_balance)
    commit('SET_TIP_DOSTAVKI', response.tip_dostavki)
    commit('SET_SVERKA_MESSAGE', response.show_sverka_message || false)
    commit('catalog/SET_DEFAULT_DOCUMENT', response.defaultDocument, { root: true })
  } else {
    commit('SET_ERROR', response.error)
  }
}

export const saveCurrentUser = async ({ commit }, payload) => {
  let response = await UserApi.saveCurrentUser(payload)
  if (response.success) {
    commit('SET_USER', response.current_user)
  } else {
    commit('SET_ERROR', response.error)
  }
}

export const changePassword = async ({ commit }, payload) => {
  let response = await UserApi.changePassword(payload)
  if (!response.success) {
    commit('SET_ERROR', response.error)
  }
}

export const setError = ({ commit }, payload) => {
  commit('SET_ERROR', payload)
}
